import { FC, useMemo } from 'react';

import { L10nText } from '@pp/core/src/services/uiTranslations/reactBindings/L10nText';
import { useSettingsSlice } from '@pp/core/src/store/slices/settings/selectors';

import { getDateTime, numberFormatter } from '../../../../../config/utils';
import { useHighflyerGameStateSlice } from '../../../../../store/slices/highflyerGame/selectors';
import { openHashModel } from '../../../tableHistory/openHashModal';

import styles from './CashedMultipliersAndWinBottomBar.module.css';

interface CashedMultipliersAndWinBottomBarProps {
  nickname: string;
  betTime: string;
  crashMul: string;
  currentTab?: string;
  index: number;
  showStaticData?: boolean;
}

export const CashedMultipliersAndWinBottomBar: FC<CashedMultipliersAndWinBottomBarProps> = ({
  nickname,
  betTime,
  crashMul,
  currentTab,
  index,
  showStaticData = false,
}) => {
  const locale = useSettingsSlice.currentLanguage();
  const betDay = getDateTime(betTime, 'day')?.toString() ?? '';
  const betMonth = getDateTime(betTime, 'month')?.toString() ?? '';

  const formatedNumber = useMemo(() => {
    return numberFormatter(Number(crashMul), locale);
  }, [locale, crashMul]);

  const formattedMultiplier = formatedNumber;
  const topWinResult = useHighflyerGameStateSlice.tableTopData()?.wins;
  const topCashedResult = useHighflyerGameStateSlice.tableTopData()?.cashouts;

  const openModal = (index: number): void => {
    // audioTrigger.play({ name: 'menuClick' });
    const tab = !!currentTab ? 'win' : 'cashed';
    const result = !!currentTab ? topWinResult[index] : topCashedResult[index];
    openHashModel(
      index,
      tab,
      result.multiplier,
      result.hashKey,
      result.encryptedResult,
      result.betTime?.split('.')[0].replace('T', ' ')
    );
  };

  return (
    <div className={styles.singleItem_bottom_bar_container}>
      <div>
        <div>{showStaticData ? '29 Aug' : <L10nText tk={betMonth} dynamicValues={{ date: betDay }} />}</div>
        <div>{nickname}</div>
      </div>
      <div className={styles.round}>
        <span>
          {showStaticData ? 'Round' : <L10nText tk={'ROUND'} />}:<span>&nbsp;</span>
        </span>
        <span className={styles.roundsMultiplier} onClick={() => openModal(index)}>
          {formattedMultiplier}x
        </span>
      </div>
    </div>
  );
};
